import React, { Component } from 'react';
import TeamHeaderRow from './TeamHeaderRow';
import TeamTotalsRow from './TeamTotalsRow';
import PlayerRow from './PlayerRow';
import './TeamBoxScore.css';

class TeamBoxScore extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sortKey: "name",
            sortDescending: 1,
        };
        this.changeSortOrder = this.changeSortOrder.bind(this);
    }

    changeSortOrder(key) {
        if (key !== this.state.sortKey) {
            this.setState({
                sortKey: key,
                sortDescending: 1,
            });
        } else {
            this.setState({
                sortDescending: -1 * this.state.sortDescending,
            });
        }
    }   

    render() {
        let players = this.props.players
            .sort((a, b) => this.state.sortDescending * (a.sortKey[this.state.sortKey] - b.sortKey[this.state.sortKey]))
            .map(function (p) {
                return <PlayerRow key={p.personId} {...p} />;
            });

        return (
            <div className="game-view">
                <div className="nba-stat-table__caption">
                    <a href={`https://stats.nba.com/team/${this.props.t_id}/`}>{this.props.name}</a>
                </div>
                <div className="nba-stat-table">
                    <table>
                        <thead>
                            <TeamHeaderRow changeSortOrder = {this.changeSortOrder}/>
                        </thead>
                        <tbody>
                            {players}
                        </tbody>
                        <tfoot>
                            <TeamTotalsRow {...this.props.totals} />
                        </tfoot>
                    </table>
                </div>
            </div>
        );
    }
}

export default TeamBoxScore;